import { RouteType } from "types/RouteType";
import AnalysisQueueStore from "./AnalysisQueueStore";

/**
 * The handoff to a producer (Gantry), made visible.
 *
 * `requiresPermission: false` and no tier gate here, deliberately: the QUEUE
 * SERVICE gates itself. `meeting-analysis-queue` requires the operator tier for
 * a human caller (or the `meeting-analysis:produce` scope for a machine), so a
 * viewer who reaches this route gets an empty screen and an error rather than
 * data. Gating in the route as well would be a second gate that could drift
 * from the real one — and the real one is the server's.
 */
const analysisQueueRoute: RouteType[] = [
  {
    name: "AnalysisQueue",
    path: "/meeting-analysis-queue",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Analysis Queue",
        enableRefreshButton: true,
        component: () => import("./AnalysisQueue.Header"),
      },
      body: {
        component: () => import("./AnalysisQueue.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: [
      "gantry",
      "deep analysis",
      "producer queue",
      "send to gantry",
      "video",
      "recording",
    ],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      (rootStore.analysisQueueStore as AnalysisQueueStore)?.load();
    },
  },
];

export default analysisQueueRoute;
